import React from 'react';
import { Loader2Icon } from 'lucide-react';

import { cn } from '../../utils/cn';

export const Spinner = React.forwardRef<
    SVGSVGElement,
    React.ComponentPropsWithoutRef<'svg'>
>(function Spinner({ className, ...props }, ref) {
    return (
        <Loader2Icon
            ref={ref}
            role="status"
            aria-label="Loading"
            className={cn('size-4 animate-spin', className)}
            {...props}
        />
    );
});
